const Signup = () => {
    return (
        <div>
            Signup page
        </div>
    )
}

export default Signup
